var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topic-button",on:{"click":_vm.gotoPage}},[(_vm.showImage)?_c('img',{staticClass:"topic-icon",attrs:{"src":_vm.imgUrl},on:{"error":_vm.imageError}}):_vm._e(),_vm._v(" "),_c('span',{class:{'no-image': !_vm.showImage},domProps:{"innerHTML":_vm._s(_vm.topicLabel)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a6e4bd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopicButton.vue
// module id = null
// module chunks = 